module.exports = __webpack_public_path__ + "static/img/KM.dc2b7340.svg";